import { ChevronLeft, ChevronRight } from "lucide-react"
import logo from "@assets/images/logo.png"
import { createContext, useContext, useState } from "react"
import { Button } from "@components/shares";

const SidebarContext = createContext<{ expanded: boolean }>({ expanded: true });

export function Sidebar({ children }:any) {
    const [expanded, setExpanded] = useState(true)
    return (
        <>
            <aside className="h-screen">
                <nav className="h-full flex flex-col bg-white border-r shadow-sm">
                    <div className="p-4 pb-5 flex justify-center">
                        <img src={logo} className={`overflow-hidden transition-all ${expanded ? "w-100" : "w-0"}`} />
                    </div>

                    <SidebarContext.Provider value={{ expanded }}>

                        <ul className="flex-1 px-3">{children}</ul>
                    </SidebarContext.Provider>

                    <div className=" flex p-3">
                        <div className={`flex justify-between items-center overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-[50px]"} `}>
                            <div className="">
                                <Button className="bg-white hover:bg-white border-none" onClick={() => setExpanded((curr) => !curr)}>
                                  {
                                    expanded ? (
                                      <div className="flex justify-center">
                                      <ChevronLeft className="text-primary"/>
                                      <span className="text-black">Thu gọn Menu</span>
                                      </div>
                                    ) : <ChevronRight className="text-primary"/>
                                  }
                                </Button>
                            </div>
                        </div>
                    </div>
                </nav>
            </aside>
        </>
    )
}

export function SidebarItem({ icon, text, active, alert }:any) {
    const { expanded}: any = useContext(SidebarContext)
    return (
        <li className={`relative flex items-center py-2 px-3 mb-3 font-medium rounded-md cursor-pointer transition-colors group ${active ? "bg-primary text-white" : "hover:bg-indigo-50 text-primary"}`}>
            {icon}
            <span className={`overflow-hidden transition-all ${active ? 'text-white': 'text-black'} ${expanded ? "w-52 ml-3" : "w-0"}`}>{text}</span>
            {alert && (
                <div className={`absolute right-2 w-2 h-2 rounded bg-primary ${expanded ? "" : "top-2"}`}>

                </div>
            )}

            {!expanded && (
                <div className={`absolute left-full rounded-md px-2 py-1 ml-6 bg-indigo-100 text-primary text-sm invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0`}>
                    {text}
                </div>
            )}
        </li>
    )
}